import { useMemo } from 'react';
import { colors, ITableProps, Row, Table, Text } from 'common-components';
import { ColumnsType } from 'antd/lib/table';
import { localizeDateTime, openLink } from '@utils';
import { useNavigate, useParams } from 'react-router';
import { getWirkUrl } from '@definitions';
import { useAuth } from 'react-oidc-context';
import { HitType } from '@types';
import { useAppTranslation } from '@hooks';

type ContributionTablePropsType = {
  hitsAchievement: HitType[]
  tableProps?: Partial<ITableProps<HitType>>
};
const ContributionTable = ({ hitsAchievement, tableProps = {} }: ContributionTablePropsType) => {
  const navigate = useNavigate();
  const params = useParams();
  const { user } = useAuth();
  const { translate } = useAppTranslation();
  const onHitClick = (idHit: string) => {
    openLink(
      `${getWirkUrl('Form')}/contribute/view/${idHit}?token=${user.access_token}&tenant=${
        params.tenant
      }`,
    );
  };
  const tableColumns: ColumnsType<HitType> = useMemo(
    () => [
      {
        title: translate('contribution.table.hit'),
        dataIndex: 'idHit',
        key: 'idHit',
        render: (idHit: HitType['idHit']) => (
          <Text size="xs" color={colors.gray900} style={{ fontWeight: 500 }}>
            {idHit}
          </Text>
        ),
      },
      {
        title: translate('common.date'),
        dataIndex: 'supportDateTime',
        key: 'supportDateTime',
        render: (supportDateTime: HitType['supportDateTime']) => (
          <Row align={'middle'}>{localizeDateTime(supportDateTime)}</Row>
        ),
      },
      /* HIDE
			{
				title: "Temps effectif",
				dataIndex: "effectiveTime",
				key: "effectiveTime",
				render: (effectiveTime) => <Row align={"middle"}>{effectiveTime}</Row>,
			},
			{
				title: "Qualité",
				dataIndex: "quality",
				key: "quality",
				render: (quality) => (
					<Row align={"middle"}>
						<DotComponent activeDots={quality} />
					</Row>
				),
			},*/
    ],
    [],
  );

  const onRowClick = useMemo(
    () => (record: HitType) => ({
      onClick: () => {
        onHitClick(record.idHit);
      },
    }),
    [navigate],
  );

  return <Table onRow={onRowClick} data={hitsAchievement} rowKey="idHit" columns={tableColumns} {...tableProps} />;
};

export default ContributionTable;
